var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8BoxImportant50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "M44,24c0,11-9,20-20,20S4,35,4,24S13,4,24,4S44,13,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M26,27h-4V13h4V27z M22,33c0-1.1,0.9-2,2-2s2,0.9,2,2c0,1.1-0.9,2-2,2S22,34.1,22,33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8BoxImportant50);
export default __webpack_public_path__ + "static/media/icons8-box-important-50.c8bdb107ef564efff56fa54fbf1ed70c.svg";
export { ForwardRef as ReactComponent };